import { GlobalAppState } from '@model/state';

export const getShareLink = (state: GlobalAppState) => state.app.shareLink;
